import React from "react"
import { FaEye } from "react-icons/fa"

import { Checkbox, LazyImage, Tooltip } from "components"
import classes from "./FuwgCard.module.scss"
import { useTranslation } from "react-i18next"

const FuwgCard = props => {
  const {
    image,
    isSelected,
    onSelect,
    onOpenLightBox
  } = props

  const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      <div className={classes["wrapper"]}>
        <div className={classes["header"]}>
          <Checkbox
            onChange={() => onSelect(image)}
            checked={isSelected}
          />
          <Tooltip title={t("مشاهده_عکس")}>
            <button
              className={classes["eye"]}
              onClick={() => onOpenLightBox(image.imageIndex)}
            >
              <FaEye />
            </button>
          </Tooltip>
        </div>
        <LazyImage
          src={image.url}
          className={classes["image"]}
          alt={image.name}
          imageWidth={100}
          quality={40}
          onClick={() => onSelect(image)}
        />
      </div>
    </div>
  )
}

export default React.memo(FuwgCard)